export default "__VITE_ASSET__VeeB0u$___"